export const errorCodeMessages = {
  // COMMON

  // LOGIN
  410006: 'Invalid email address and/or password.',
  410009: 'Invalid email address and/or password.',
  410015: 'Invalid email address and/or password.',
  4100231:
    'Your account has not activated yet. <br /> Please check your mailbox and press ‘Confirm Email Address’ button.',
  410031:
    'Your account has not activated yet. <br /> Please check your mailbox and press ‘Confirm Email Address’ button.',

  // SIGNUP
  410010: 'Your email has already been registered',

  // Reset Password
  410008:
    'Unregistered email account. Please confirm you entered it correctly.',

  // Invite User Popup
  410028: 'User already exists.',

  validation: {
    1000: '"From Date" must be less than or equal to "To Date".',
  },
};
